import { TeliaButton, TeliaIcon } from '@teliads/components/react';
import { useTranslation } from 'react-i18next';

import BaseModal from '../base-modal/BaseModal';

import Paragraph from 'components/voca/paragraph/Paragraph';

import './AlertToast.scss';

type Props = {
  variant: 'success' | 'error';
  preamble: string;
  onClose: () => void;
  isOpen: boolean;
};

export default function AlertToast({ variant, preamble, onClose, isOpen }: Props) {
  const { t } = useTranslation();

  function getTitle() {
    switch (variant) {
      case 'success':
        return t('success');
      case 'error':
        return t('error');
    }
  }

  function getIconCode() {
    switch (variant) {
      case 'success':
        return 'check-circle-filled';
      case 'error':
        return 'alert-filled';
    }
  }

  return (
    <BaseModal
      variant="center"
      header={getTitle()}
      onClose={onClose}
      isOpen={isOpen}
      isRenderedOnOpen
    >
      <figure className="alert-toast">
        <TeliaIcon
          allyTitle={variant === 'success' ? 'Success circle' : 'Alert circle'}
          className="alert-toast__icon"
          name={getIconCode()}
          size="lg"
          data-testid="alert-toast-telia-icon"
        />

        <Paragraph
          className="alert-toast__preamble"
          variant="paragraph-100"
          dataTestId="alert-toast-preamble"
        >
          {preamble}
        </Paragraph>

        <div className="alert-toast__button-wrapper">
          <TeliaButton
            className="alert-toast__button"
            allyLabel="Close modal"
            variant="primary"
            onClick={onClose}
            data-testid="alert-toast-button"
            type="button"
            fullWidth
          >
            OK
          </TeliaButton>
        </div>
      </figure>
    </BaseModal>
  );
}
